import type { SVGProps } from 'react'

export const CheckMark = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<circle cx="10" cy="10" r="6" fill="#131E29" />
		<path
			d="M9.99996 1.66669C5.40496 1.66669 1.66663 5.40502 1.66663 10C1.66663 14.595 5.40496 18.3334 9.99996 18.3334C14.595 18.3334 18.3333 14.595 18.3333 10C18.3333 5.40502 14.595 1.66669 9.99996 1.66669ZM13.567 8.5671L9.40038 12.7338C9.27829 12.8559 9.11829 12.9167 8.95829 12.9167C8.79829 12.9167 8.63829 12.8559 8.51621 12.7338L6.43288 10.6504C6.18871 10.4063 6.18871 10.0109 6.43288 9.76669C6.67704 9.52252 7.07246 9.52252 7.31663 9.76669L8.95788 11.4079L12.6825 7.68335C12.9266 7.43919 13.322 7.43919 13.5662 7.68335C13.8104 7.92752 13.8108 8.32294 13.567 8.5671Z"
			fill="currentColor"
		/>
	</svg>
)
